<template>
    <div class="toast-container">
        <TransitionGroup name="toast-list" tag="div" class="toast-stack">
        <component
            :is="getToastComponent(toast.type)"
            v-for="toast in notificationStore.toasts"
            :key="toast.id"
            :title="toast.message"
            :description="toast.description"
            :icon="getIcon(toast.type)"
            :timeToClose="resolveTimeToClose(toast)"
            :show-action="Boolean(toast.isConfirm)"
            :action-label="toast.confirmLabel || 'Confirm'"
            @close="handleClose(toast)"
            @action="handleAction(toast)"
        />
        </TransitionGroup>
    </div>
</template>

<script setup>
import { useNotificationStore } from '@/store/pinia/notifications';
import ConfirmationToast from './ConfirmationToast.vue';
import ProblemToast from '@components/ProblemToast/ProblemToast.vue';

const notificationStore = useNotificationStore();

const iconMap = {
    success: 'confirmation_toast_icon',
    error: 'problem_toast_icon',
    warning: 'obsolete_lightning_bolt',
    info: 'notification_bell',
    confirm: 'confirmation_toast_icon'
};

const getIcon = (type) => iconMap[type] || 'confirmation_toast_icon';

const getToastComponent = (type) => {
    return type === 'error' ? ProblemToast : ConfirmationToast;
};

const resolveTimeToClose = (toast) => {
    if (toast.duration != null) return toast.duration;
    if (toast.isConfirm) return 0;
    return 5000;
};

const handleClose = (toast) => {
    if (toast?.isConfirm && typeof toast.onCancel === 'function') {
        toast.onCancel();
    }
    notificationStore.removeToast(toast.id);
};

const handleAction = (toast) => {
    if (typeof toast.onConfirm === 'function') {
        toast.onConfirm();
    }
    notificationStore.removeToast(toast.id);
};
</script>

<style scoped>
.toast-container {
    position: fixed;
    top: 24px;
    right: 24px;
    z-index: 9999;
    pointer-events: none;
}

.toast-stack {
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: flex-end;
}

.toast-stack > * {
    pointer-events: auto;
}

.toast-list-enter-active,
.toast-list-leave-active {
    transition: all 0.3s ease;
}

.toast-list-enter-from {
    opacity: 0;
    transform: translateX(100px);
}

.toast-list-leave-to {
    opacity: 0;
    transform: translateX(100px) scale(0.8);
}

.toast-list-move {
    transition: transform 0.3s ease;
}
</style>
